// menuItems.tsx
import {IconType} from 'react-icons'
import {ImHourGlass} from 'react-icons/im'
import {
  FiGrid,
  FiUsers,
  FiBell,
  FiTablet,
  FiClock,
  FiArchive,
  FiFileText,
  FiCreditCard,
} from 'react-icons/fi'
import {FaUserDoctor} from 'react-icons/fa6'
import {RiNurseLine} from 'react-icons/ri'
import {GrUserAdmin} from 'react-icons/gr'
import {FaUserMd} from 'react-icons/fa'

export interface SidebarItem {
  title: string
  to: string
  icon: IconType
  children?: SidebarItem[]
}

const menuItems: SidebarItem[] = [
  {title: 'Dashboard', to: '/dashboard', icon: FiGrid},
  {title: 'Doctors', to: '/doctor', icon: FaUserDoctor},
  {title: 'Sub Admin', to: '/sub-admin', icon: GrUserAdmin},
  {title: 'Medical Assistant', to: '/medical-assistant', icon: FaUserMd},
  {title: 'Staff', to: '/staff', icon: RiNurseLine},
  {
    title: 'Patients',
    to: '#',
    icon: FiUsers,
    children: [
      {title: 'Patient List', to: '/patient', icon: FiUsers},
      {title: 'Time Tracked', to: '/time-tracked', icon: FiClock},
    ],
  },
  {title: 'My Devices', to: '/my/devices', icon: FiTablet},
  {title: 'All Devices', to: '/list/devices', icon: FiTablet},
  // {title: 'Health Alerts', to: '/health-alerts/settings', icon: FiAlertCircle},
  {title: 'Notification Settings', to: '/settings/alerts', icon: FiBell},
//   {title: 'Payment History', to: '/payment-history', icon: FiDollarSign},
  {
    title: 'Reports',
    to: '#',
    icon: FiArchive,
    children: [
      {
        title: 'Billing Report',
        to: '/billing-report',
        icon: FiFileText,
      },
      {
        title: 'Cycle Ending Soon',
        to: '/billing-cycle-ending-report',
        icon: ImHourGlass,
      },
    ],
  },
  {
    title: 'All Billing Reports',
    to: '/admin/billing-report',
    icon: FiFileText,
  },
  {title: 'Subscription', to: '/subscription', icon: FiCreditCard},

]

export default menuItems
